import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../style/gibraltar.css';

// Importing images for Sri Lanka (1-62)
import srilanka1 from '../images/srilanka1.jpeg';
import srilanka2 from '../images/srilanka2.jpeg';
import srilanka3 from '../images/srilanka3.jpeg';
import srilanka4 from '../images/srilanka4.jpeg';
import srilanka5 from '../images/srilanka5.jpeg';
import srilanka6 from '../images/srilanka6.jpeg';
import srilanka7 from '../images/srilanka7.jpeg';
import srilanka8 from '../images/srilanka8.jpeg';
import srilanka9 from '../images/srilanka9.jpeg';
import srilanka10 from '../images/srilanka10.jpeg';
import srilanka11 from '../images/srilanka11.jpeg';
import srilanka12 from '../images/srilanka12.jpeg';
import srilanka13 from '../images/srilanka13.jpeg';
import srilanka14 from '../images/srilanka14.jpeg';
import srilanka15 from '../images/srilanka15.jpeg';
import srilanka16 from '../images/srilanka16.jpeg';
import srilanka17 from '../images/srilanka17.jpeg';
import srilanka18 from '../images/srilanka18.jpeg';
import srilanka19 from '../images/srilanka19.jpeg';
import srilanka20 from '../images/srilanka20.jpeg';
import srilanka21 from '../images/srilanka21.jpeg';
import srilanka22 from '../images/srilanka22.jpeg';
import srilanka23 from '../images/srilanka23.jpeg';
import srilanka24 from '../images/srilanka24.jpeg';
import srilanka25 from '../images/srilanka25.jpeg';
import srilanka26 from '../images/srilanka26.jpeg';
import srilanka27 from '../images/srilanka27.jpeg';
import srilanka28 from '../images/srilanka28.jpeg';
import srilanka29 from '../images/srilanka29.jpeg';
import srilanka30 from '../images/srilanka30.jpeg';
import srilanka31 from '../images/srilanka31.jpeg';
import srilanka32 from '../images/srilanka32.jpeg';
import srilanka33 from '../images/srilanka33.jpeg';
import srilanka34 from '../images/srilanka34.jpeg';
import srilanka35 from '../images/srilanka35.jpeg';
import srilanka36 from '../images/srilanka36.jpeg';
import srilanka37 from '../images/srilanka37.jpeg';
import srilanka38 from '../images/srilanka38.jpeg';
import srilanka39 from '../images/srilanka39.jpeg';
import srilanka40 from '../images/srilanka40.jpeg';
import srilanka41 from '../images/srilanka41.jpeg';
import srilanka42 from '../images/srilanka42.jpeg';
import srilanka43 from '../images/srilanka43.jpeg';
import srilanka44 from '../images/srilanka44.jpeg';
import srilanka45 from '../images/srilanka45.jpeg';
import srilanka46 from '../images/srilanka46.jpeg';
import srilanka47 from '../images/srilanka47.jpeg';
import srilanka48 from '../images/srilanka48.jpeg';
import srilanka49 from '../images/srilanka49.jpeg';
import srilanka50 from '../images/srilanka50.jpeg';
import srilanka51 from '../images/srilanka51.jpeg';
import srilanka52 from '../images/srilanka52.jpeg';
import srilanka53 from '../images/srilanka53.jpeg';
import srilanka54 from '../images/srilanka54.jpeg';
import srilanka55 from '../images/srilanka55.jpeg';
import srilanka56 from '../images/srilanka56.jpeg';
import srilanka57 from '../images/srilanka57.jpeg';
import srilanka58 from '../images/srilanka58.jpeg';
import srilanka59 from '../images/srilanka59.jpeg';
import srilanka60 from '../images/srilanka60.jpeg';
import srilanka61 from '../images/srilanka61.jpeg';
import srilanka62 from '../images/srilanka62.jpeg';

function SriLanka() {
  const navigate = useNavigate();
  const [selectedImageIndex, setSelectedImageIndex] = useState(null);

  // Array of all imported images
  const photos = [
    srilanka1, srilanka2, srilanka3, srilanka4, srilanka5, srilanka6, srilanka7, srilanka8, srilanka9, srilanka10,
    srilanka11, srilanka12, srilanka13, srilanka14, srilanka15, srilanka16, srilanka17, srilanka18, srilanka19, srilanka20,
    srilanka21, srilanka22, srilanka23, srilanka24, srilanka25, srilanka26, srilanka27, srilanka28, srilanka29, srilanka30,
    srilanka31, srilanka32, srilanka33, srilanka34, srilanka35, srilanka36, srilanka37, srilanka38, srilanka39, srilanka40,
    srilanka41, srilanka42, srilanka43, srilanka44, srilanka45, srilanka46, srilanka47, srilanka48, srilanka49, srilanka50,
    srilanka51, srilanka52, srilanka53, srilanka54, srilanka55, srilanka56, srilanka57, srilanka58, srilanka59, srilanka60,
    srilanka61, srilanka62
  ];

  // Function to handle image click
  const handleImageClick = (index) => {
    setSelectedImageIndex(index);
  };

  // Function to close the modal
  const closeModal = () => {
    setSelectedImageIndex(null);
  };

  // Function to navigate to the previous image
  const goToPrevious = () => {
    setSelectedImageIndex((prevIndex) =>
      prevIndex === 0 ? photos.length - 1 : prevIndex - 1
    );
  };

  // Function to navigate to the next image
  const goToNext = () => {
    setSelectedImageIndex((prevIndex) =>
      prevIndex === photos.length - 1 ? 0 : prevIndex + 1
    );
  };

  return (
    <div className="gibraltar-page">
      <h1>🇱🇰 Sri Lanka 2017 🇱🇰</h1>
      <button className="back-button" onClick={() => navigate(-1)}>
        &larr; 
      </button>

      <div className="photo-grid">
        {photos.map((photo, index) => (
          <div
            key={index}
            className="photo-item"
            onClick={() => handleImageClick(index)}
          >
            <img src={photo} alt={`Sri Lanka ${index + 1}`} />
          </div>
        ))}
      </div>

      {/* Modal for displaying the larger image */}
      {selectedImageIndex !== null && (
        <div className="modal" onClick={closeModal}>
          <div className="modal-content">
            <button className="arrow left-arrow" onClick={(e) => { e.stopPropagation(); goToPrevious(); }}>
              &larr;
            </button>
            <img
              src={photos[selectedImageIndex]}
              alt="Selected"
              className="modal-image"
            />
            <button className="arrow right-arrow" onClick={(e) => { e.stopPropagation(); goToNext(); }}>
              &rarr;
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default SriLanka;